import { DeliveryOrderBatchResultPage } from "@/features/delivery-order-batch/pages/DeliveryOrderBatchResultPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/admin/delivery-order-batch/$deliveryOrderBatchID/result",
)({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({ permissions: ["delivery_order.batch_generate"] })
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: DeliveryOrderBatchResultPage,
});
